import store from '~/store'

export default (to, from, next) => {
  if (store.getters['auth/user'].role !== 2) {
    next({ name: 'sold-out-products' })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/admin.js